<div>
  <div style="display: flex; align-items: flex-end; gap: 15px; height: 40px">
    <div class="expanded-info-section-title">{{ 'Settings.Configuration' | translate }}</div>
    <div (click)="show = !show" style="cursor: pointer">
      <mat-icon style="font-size: 24px" *ngIf="show">keyboard_arrow_up</mat-icon>
      <mat-icon style="font-size: 24px" *ngIf="!show">chevron_right</mat-icon>
    </div>
  </div>

  <div *ngIf="show" class="box-shadow">
    <div class="expanded-info-parent-config" style="padding: 4px">
      <div class="config-section">
        <h3 class="config-section-title">{{ 'Settings.DeviceTestingMap' | translate }}</h3>
        <div *ngFor="let receiver of company.receivers">
          <div class="expanded-info-title" style="margin-bottom: 10px; font-weight: bold">
            {{ receiver?.name?.toUpperCase() ?? '-' }}
          </div>
          <div style="display: flex; flex-direction: row; gap: 100px">
            <div>
              <div class="expanded-info-title" style="margin-top: 0px">
                {{ ('Settings.WeakSignal' | translate).toUpperCase() }}
              </div>
              <div class="expanded-info-value" style="padding-bottom: 12px">
                {{ receiver.testPHourConfiguration.lowControl || '-' }}
              </div>
            </div>
            <div>
              <div class="expanded-info-title" style="margin-top: 0px">
                {{ ('Settings.ExcellentSignal' | translate).toUpperCase() }}
              </div>
              <div class="expanded-info-value" style="padding-bottom: 12px">
                {{ receiver.testPHourConfiguration.goodControl || '-' }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- IA - Kairon -->
      <div class="config-section" *ngIf="isKaironEnabled()">
        <h3 class="config-section-title">{{ 'Settings.AIKairon' | translate }}</h3>

        <div class="config-item">
          <div class="config-toggle-container">
            <ui-switch
              [(ngModel)]="company.kairon.isEnabled"
              (valueChange)="onKaironIsEnabledChange(company, $event)"
              [disabled]="true"
            ></ui-switch>
            <span class="enabled-disabled-label"
              >{{ company.kairon?.isEnabled ? ('Settings.Enabled' | translate) : ('Settings.Disabled' | translate)
              }}</span
            >
          </div>
        </div>
      </div>
    </div>
    <div class="expanded-info-parent">
      <div class="expanded-info-column">
        <h3 class="config-section-title">{{ 'Settings.PowerCut' | translate }}</h3>

        <div style="display: flex; gap: 73px">
          <div>
            <div class="expanded-info-title" style="margin-top: 0px">
              {{ ('Settings.RegionDistance' | translate).toUpperCase() }}
            </div>
            <div class="expanded-info-value" style="padding-bottom: 12px">
              {{ company.kairon.eventDetectionConfig.radiusMeters }} {{ 'AppComponent.Meters' | translate }}
            </div>
          </div>
          <div>
            <div class="expanded-info-title" style="margin-top: 0px">
              {{ ('Settings.CustomContactId' | translate).toUpperCase() }}
            </div>
            <div class="expanded-info-value" style="padding-bottom: 12px">
              {{ company.kairon.eventDetectionConfig.eventCID ? company.kairon.eventDetectionConfig.eventCID : '-' }}
            </div>
          </div>
        </div>

        <h3 class="config-section-title">{{ 'Settings.ControlSchedule' | translate }}</h3>
        <div style="display: flex; gap: 40px">
          <div>
            <div class="expanded-info-title" style="margin-top: 0px">
              {{ ('Settings.ToleranceTime' | translate).toUpperCase() }}
            </div>
            <div class="expanded-info-value">
              {{ company.kairon.reminderConfig.toleranceMinutes }} {{ 'AppComponent.Minutes' | translate }}
            </div>
          </div>
          <div>
            <div class="expanded-info-title" style="margin-top: 0px">
              {{ ('Settings.ReminderTime' | translate).toUpperCase() }}
            </div>
            <div class="expanded-info-value">
              {{ company.kairon.reminderConfig.retryMinutes }} {{ 'AppComponent.Minutes' | translate }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- IA - Kairon por voz -->
    <div class="config-section" *ngIf="canManageKaironVoice()">
      <h3 class="config-section-title">{{ 'Settings.AIKaironVoice' | translate }}</h3>

      <div class="config-item">
        <div class="config-toggle-container">
          <ui-switch [ngModel]="company.kairon?.voice?.isEnabled" [disabled]="true"></ui-switch>
          <span class="enabled-disabled-label"
            >{{ company.kairon?.voice?.isEnabled ? ('Settings.Enabled' | translate) : ('Settings.Disabled' | translate)
            }}</span
          >
        </div>
      </div>

      <div *ngIf="company.kairon?.voice?.isEnabled" style="display: flex; gap: 73px; flex-wrap: wrap">
        <div>
          <div class="expanded-info-title" style="margin-top: 0px">
            {{ ('Settings.VoiceCallRetries' | translate).toUpperCase() }}
          </div>
          <div class="expanded-info-value" style="padding-bottom: 12px">
            {{ company.kairon.voice.callRetryLimit ?? '-' }}
          </div>
        </div>
        <div>
          <div class="expanded-info-title" style="margin-top: 0px">
            {{ ('Settings.VoiceCIDFalseAlarm' | translate).toUpperCase() }}
          </div>
          <div class="expanded-info-value" style="padding-bottom: 12px">
            {{ company.kairon.voice.cidFalseAlarm || '-' }}
          </div>
        </div>
        <div>
          <div class="expanded-info-title" style="margin-top: 0px">
            {{ ('Settings.VoiceCIDDuress' | translate).toUpperCase() }}
          </div>
          <div class="expanded-info-value" style="padding-bottom: 12px">
            {{ company.kairon.voice.cidDuress || '-' }}
          </div>
        </div>
        <div>
          <div class="expanded-info-title" style="margin-top: 0px">
            {{ ('Settings.VoiceCIDNoContact' | translate).toUpperCase() }}
          </div>
          <div class="expanded-info-value" style="padding-bottom: 12px">
            {{ company.kairon.voice.cidNoContact || '-' }}
          </div>
        </div>
        <div>
          <div class="expanded-info-title" style="margin-top: 0px">
            {{ ('Settings.VoiceCIDCommFailure' | translate).toUpperCase() }}
          </div>
          <div class="expanded-info-value" style="padding-bottom: 12px">
            {{ company.kairon.voice.cidCommFailure || '-' }}
          </div>
        </div>
      </div>
    </div>

    <!-- IA - Maia -->
    <div class="config-section" *ngIf="isMaiaEnabled()">
      <h3 class="config-section-title">{{ 'Settings.AIMaia' | translate }}</h3>

      <div class="config-item">
        <div class="config-toggle-container">
          <ui-switch [(ngModel)]="company.maia.isEnabled" [disabled]="true"></ui-switch>
          <span class="enabled-disabled-label"
            >{{ company.maia?.isEnabled ? ('Settings.Enabled' | translate) : ('Settings.Disabled' | translate) }}</span
          >
        </div>
      </div>

      <div class="expanded-info-parent">
        <div class="expanded-info-column">
          <h3 class="config-section-title">{{ 'Settings.AlertEventSend' | translate }}</h3>

          <div style="display: flex; gap: 40px">
            <div>
              <div class="expanded-info-title" style="margin-top: 0px">
                {{ ('Settings.PerimetralArmPeriod' | translate).toUpperCase() }}
              </div>
              <div class="expanded-info-value" style="padding-bottom: 12px">
                {{ company.maia.perimetralConfig.startHour ?? '--:--' }} {{ 'hs' }}
              </div>
            </div>
            <div>
              <div class="expanded-info-title" style="margin-top: 0px">
                {{ ('Settings.PerimetralArmPeriodEnd' | translate).toUpperCase() }}
              </div>
              <div class="expanded-info-value" style="padding-bottom: 12px">
                {{ company.maia.perimetralConfig.endHour ?? '--:--' }} {{ 'hs' }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
